import { render } from "./ClienteFichCada.vue?vue&type=template&id=3e2c0c6e&scoped=true"
import script from "./ClienteFichCada.vue?vue&type=script&lang=js"
export * from "./ClienteFichCada.vue?vue&type=script&lang=js"

import "./ClienteFichCada.vue?vue&type=style&index=0&id=3e2c0c6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2c0c6e"]])

export default __exports__